import React from 'react';
import './CreditOption.css';

function CreditOption({ creditAmount, isSelected, onToggle, formatAud }) {
  return (
    <div className="credit-option-container">
      <div className="credit-header">
        <h3>Available Credit</h3>
        <span className="credit-amount">{formatAud(creditAmount)}</span>
      </div>
      <div className="credit-selection">
        <div className="credit-checkbox-wrapper">
          <input
            type="checkbox"
            id="use-credit"
            name="use-credit"
            checked={isSelected}
            onChange={onToggle}
          />
          <label htmlFor="use-credit" className="credit-label">
            <span className="credit-label-text">Use my credit for this order</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default CreditOption;

